module.exports = __webpack_public_path__ + "static/img/nodata.e2ff92da.png";